import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import { forwardRef } from 'react';
import { RegistersPanelBody } from '../../context/PanelComponentRegistrationContext';
import styled from 'foundations-theming/utils';
import { StyledSection } from '../Section/Section';
import { filterProps } from '../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledPanelBody = styled.div.withConfig({
  displayName: "PanelBody__StyledPanelBody",
  componentId: "sc-1k0c9w0-0"
})(({
  theme,
  $cssStyles
}) => {
  return Object.assign({
    flex: '1 1 100%',
    overflow: 'auto',
    padding: 0,
    position: 'relative',
    minHeight: 'auto',
    backgroundColor: theme.color['fill-surface-default'],
    [`> ${StyledSection}[data-panel-section]`]: {
      paddingBlockStart: theme.space['600']
    }
  }, $cssStyles);
});
export const PanelBody = /*#__PURE__*/forwardRef((props, ref) => {
  const {
      children
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const {
    domProps,
    tokenProps,
    callbackProps,
    restProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsxs(StyledPanelBody, Object.assign({}, domProps, callbackProps, restProps, {
    ref: ref,
    $cssStyles: cssStyles,
    children: [/*#__PURE__*/_jsx(RegistersPanelBody, {}), children]
  }));
});
PanelBody.displayName = 'PanelBody';